import * as schemas from "~/schemas/schema.availability_records.jsx";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";
import { encodeData } from "~/utils/utils.jsx";

export const addAvailabilityRecord = (userId, attributes) => {
  return {
    types: [
      actionTypes.ADD_AVAILABILITY_RECORD_LOADING,
      actionTypes.ADD_AVAILABILITY_RECORD_SUCCESS,
      actionTypes.ADD_AVAILABILITY_RECORD_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/availability-records/users/${userId}`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      userId,
      attributes,
      schema: {
        single: schemas.availabilityRecord,
      },
    },
  };
};

export const getAvailabilityRecords = (userId, options) => {
  const query = encodeData(options);
  return {
    types: [
      actionTypes.FETCH_AVAILABILITY_RECORDS_LOADING,
      actionTypes.FETCH_AVAILABILITY_RECORDS_SUCCESS,
      actionTypes.FETCH_AVAILABILITY_RECORDS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/availability-records/users/${userId}?${query}`,
      }),
    payload: {
      userId,
      schema: schemas.arrayOfAvailabilityRecords,
    },
  };
};

export const deleteAvailabilityRecord = (id) => {
  return {
    types: [
      actionTypes.DELETE_AVAILABILITY_RECORD_LOADING,
      actionTypes.DELETE_AVAILABILITY_RECORD_SUCCESS,
      actionTypes.DELETE_AVAILABILITY_RECORD_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/availability-records/${id}`,
        method: `DELETE`,
      }),
    payload: {
      id,
    },
  };
};

export const availabilityRecordCreatedFromEventStream = (data) => {
  return {
    type: actionTypes.ADD_AVAILABILITY_RECORD_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemas.availabilityRecord,
    userId: data.user_id,
  };
};

export const availabilityRecordUpdatedFromEventStream = (data) => {
  return {
    type: actionTypes.EDIT_AVAILABILITY_RECORD_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemas.availabilityRecord,
    userId: data.user_id,
  };
};

export const availabilityRecordDeletedFromEventStream = (data) => {
  return {
    type: actionTypes.DELETE_AVAILABILITY_RECORD_FROM_EVENT_STREAM_SUCCESS,
    id: data.id,
  };
};
